export const confirmdialog = {
  icon: {
    size: "28px",
    color: "{overlay.modal.color}",
  },
  content: {
    gap: "{gap.16}",
  },
  extend: {
    ui: {
      root: {
        width: "{container.confirm}",
      },
    },
  },
  css: ({ dt }: any): string => `
    .p-confirmdialog {
      width: ${dt("confirmdialog.ui.width")};
    }

    .p-confirmdialog .p-dialog-footer > p-button:has(> .p-confirmdialog-reject-button) {
      order: 2;
    }

    .p-confirmdialog-message {
      white-space: pre-line;
    }
  `,
};
